import { mapping as deviceBaseMapper } from '../common/device-base/device-base-filter.mapper'

const mapping: Record<
  string,
  (lambdaParameter: string, value: any, otherValues: any) => string | null
> = {
  ...deviceBaseMapper,
  hardwareVersion: (lambdaParameter, value) =>
    `${lambdaParameter}.HardwareVersion.Equals(TicketAPI.Models.Enums.DeviceManagement.HardwareVersions.${value})`,
  tsCanId: (lambdaParameter, value) => `${lambdaParameter}.TSCan.Id==${value}`,
  search: (lambdaParameter, value) =>
    `${value
      .toString()
      .split(' ')
      .map(
        (q: string) =>
          `(${lambdaParameter}.Id+" "+${lambdaParameter}.Name).Contains("${q}")`,
      )
      .join('&&')}`,
}

const filterMapper = (key: string) =>
  mapping[key] as (
    lambdaParameter: string,
    value: any,
    otherValues: any,
  ) => string

export default filterMapper
